//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '5rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
		titleFontSize = '4rem';
	} else if (size === 'md') {
		titleFontSize = '4rem';
	} else if (size === 'sm') {
		titleFontSize = '3rem';
	}
	if (isMobile) {
		titleFontSize = '2rem';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				marginTop: mt ? `3rem` : `1rem`,
			};
		},
		titleRowStyle: () => {
			return {
				width: '100%',
				height: `auto`,
				display: 'flex',
				flexDirection: 'column',
				padding: `0 ${minimumMarginX}rem`,
			};
		},
		titleSyle: () => {
			return {
				color: 'black',
				textAlign: 'center',
				fontSize: titleFontSize,
			};
		},
		thankYouText: () => {
			return {
				marginTop: `1rem`,
			};
		},
		bannerStyle: () => {
			return {
				marginTop: '1rem',
			};
		},
	};
}

export default Styles;
